/** DEV-3667: distinguish load failure from an empty page list in the MultiSelect. */
export function pagesSelectEmptyMessage(state: { isFetching: boolean; isError: boolean }): string {
  if (state.isFetching) return 'Загрузка...';
  if (state.isError) return 'Не удалось загрузить список страниц';
  return 'Страницы не найдены';
}

export function pagesSelectFieldError(
  formError: string | undefined | null,
  isLoadError: boolean
): string | undefined {
  // Prefer load error over validation — user cannot pick a page until reload succeeds.
  if (isLoadError) return 'Не удалось загрузить список страниц';
  if (formError) return formError;
  return undefined;
}
